<template>
    <div
        class="preview-button"
    >
        <span
            class="button"
            :style="{'background-color': stepData.iconColor, 'margin-bottom': margin}"
        >
            <img
                class="step-icon"
                :src="`/static/icon/${stepData.iconUrl}`"
            >
        </span>
        <p
            class="step-title"
            :style="{'font-size': fontSize, 'margin': margin}"
            v-if="errorVerboseStatus !== ''"
        >
            {{errorVerboseStatus}}
        </p>
        <p
            v-else
            class="step-title"
            :style="{'font-size': fontSize, 'margin': margin}"
        >
            {{stepData.stepTitle}}
        </p>
        <p
            class="step-text"
            v-if="stepData.stepText"
        >
            {{stepData.stepText}}
        </p>

        <button
            class="restart-button"
            :style="{'font-size': fontSize}"
            v-if="stepData.linkText"
            @click="createNewPreview()"
        >
            {{stepData.linkText}}
        </button>
    </div>
</template>

<script>
    import PreviewStepMixin from '@/components/Mixins/preview-step-mixin.vue';
    export default {

        name: 'Error',

        mixins: [PreviewStepMixin],
        props:{
            errorVerboseStatus:{
                type: String,
            }
        },

        data () {
            return {

            };
        },
        mounted(){
        }
    };
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/Preview/PreviewStep/Error/index.vue